module.exports = __webpack_public_path__ + "img/block-illustration-reduce.svg";